// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import _ from 'lodash';
import colors from '../../assets/css/colors';
import * as selectors from "../../modules/selectors";
import * as actions from '../../modules/actions';
import isAuthenticated from '../../utils/auth/isAuthenticated';
import UserAvatar from '../../assets/images/UserAvatar.png';
import NRLFantasyLogo from '../../assets/images/nrl-fantasy-draft-logo-header.svg';
import { below, above } from "../../assets/css/media";
import Menu from '../../components/Icons/Menu.js';
import { isMobile } from '../../utils/isMobile/index';


// const SponsorLink = styled.a`
// 	display: flex;
// 	justify-content: center;
// 	align-items: center;
// 	text-decoration: none;
// 	height: 100%;

// 	span {
// 		display: flex;
// 		align-items: center;
// 		justify-content: center;
// 		height: 100%;
// 		padding: 0 16px;
// 		box-sizing: border-box;
// 		// background: #000;
// 		${below.phone`
// 			padding: 0 5px;
// 		`}
// 	}

// 	img {
// 		width: 100px;
// 		${below.phone`
// 			width: 50px;
// 		`}
// 	}
// `;

// const SponsorText = styled.div`
// 	color: #000000;
// 	font-size: 12px;
// 	font-weight: normal;
// `;


const MainHeaderStyled = styled.header`
	width: 100%;
	background: ${colors.nrlGreen};
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	padding: 0 0 0 1em;
	height: 55px;
	.nrl-logo {
		height: 100%;
		img {
		  max-height: 100%;
		}
	}
	${below.tablet`
		justify-content: flex-start;
		.nrl-logo {
			margin-left: 1em;
		}
	`};
`;

const UserAvatarWrapper = styled.a`
	width: 35px;
	height: 35px;
	// border-radius: 50%;
	overflow: hidden;
	margin-right: 10px;
	img {
		width: 100%;
	}
	${below.desktop`
		display: none;
	`}
`;

const RightBlock = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	${below.tablet`
		margin-left: auto;
	`};
`;

const ToggleMobailMenu = styled.a`
	font-size: 18px;
	color: ${colors.nrlDarkGreen};
	${above.desktop`
		display: none;
	`}
`;

type Props = {
	is_authenticated: boolean,
	avatar_url: string,
	has_user: boolean,
	openMenu: Function
};

type State = {
	is_mobile: boolean
}

class MainHeader extends React.Component<Props, State> {
	state = {
		is_mobile: isMobile(),
	};
	constructor(props: Props, state: State) {
		super(props, state);

		_.bindAll(this, [
			'resize',
		]);
	}
	componentDidMount() {
		window.addEventListener("resize", this.resize);
		this.resize();

	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.resize);
	}
	resize() {
		this.setState({
			is_mobile: isMobile()
		});
	}
	render() {
		const { is_authenticated, avatar_url, openMenu } = this.props;

		return (
			<MainHeaderStyled>
				<ToggleMobailMenu onClick={openMenu}>
					<Menu />
				</ToggleMobailMenu>
				<a href="/draft/leagues" className="nrl-logo">
					<img src={NRLFantasyLogo} alt="NRL Fantasy Logo" />
				</a>

				<RightBlock>
					{/* Placement here for sponsor logo 
						Sposnsor is disable for now waiting for new sponsor
						<SponsorLink href="https://hisense.com.au/ " target="_blank" >
						<SponsorText>Presented By</SponsorText>
						<span>
							<img src={sponsor_log} alt="swyftx.com" />
						</span>
					</SponsorLink> */}
					{is_authenticated ? (
						<UserAvatarWrapper href="/account/settings">
							{avatar_url ? (
								<img src={avatar_url} alt="" />
							) : (
								<img src={UserAvatar} alt="" />
							)}
						</UserAvatarWrapper>
					) : null}
				</RightBlock>
			</MainHeaderStyled>
		);

	}
}

const mapStateToProps = state => ({
	is_authenticated: isAuthenticated(),
	user: selectors.getUser(state),
	has_user: selectors.hasUser(state),
	avatar_url: selectors.getUserAvatar(state)
});

const mapDispatchToProps = {
	openMenu: actions.uiMenu.openHamburgerMenu,
};

export const Header = connect(mapStateToProps, mapDispatchToProps)(MainHeader);

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/index.js